import { Component } from "@angular/core";

@Component({
    selector: "health-engage",
    templateUrl: "./health-engage.component.html",
    styleUrls: ["./health-engage.component.scss"],
})
export class HealthEngageComponent {}
